const apiBaseUrl =  'https://api.ogwebguru.com/api'
const imageBaseurl =  'https://api.ogwebguru.com/uploads/'
// const apiBaseUrl =  'http://localhost:5000/api'
// const imageBaseurl =  'http://localhost:5000/uploads/'

export{
  apiBaseUrl,imageBaseurl
}